import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Editor } from 'primereact/editor';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import ChatHeader from './components/ChatHeader';
import ChatSimulator from './components/ChatSimulator';
import CurrentDraft from './components/CurrentDraft';
import ChatJourneyBuilder from './components/ChatJourneyBuilder';
import HistoryPanel from './components/HistoryPanel';
import {
  DIALOG_HEADER,
  DIALOG_WIDTH,
  DIALOG_CLASS,
  EDITOR_HEADER_BUTTONS,
  EDITOR_HEIGHT,
  QUESTION_MAX_LENGTH,
  RESPONSE_MAX_LENGTH,
  WELCOMING_MESSAGE_LABEL,
  CUSTOMER_QUESTION_LABEL,
  BOT_RESPONSE_LABEL,
  MESSAGE_EXCEED_LABEL,
  QUESTION_EXCEED_LABEL,
  RESPONSE_EXCEED_LABEL,
  SAVE_LABEL,
  CANCEL_LABEL,
  SAVE_ICON,
  PRIMARY_BUTTON_CLASS,
  TEXT_BUTTON_CLASS,
  CHAR_COUNTER_CLASS,
  P_INVALID_CLASS
} from './constant';

const renderEditorHeader = () => (
  <span className="ql-formats">
    {EDITOR_HEADER_BUTTONS.map(btn => (
      <button key={btn.className} className={btn.className} aria-label={btn.ariaLabel}></button>
    ))}
  </span>
);

const ChatJourneyTwoPanelView = ({
  toast,
  isEnabled,
  handleToggleChange,
  showSimulator,
  setShowSimulator,
  saveChatJourney,
  isMobile,
  chatHistory,
  setChatHistory,
  currentNode,
  parentNode,
  handleUserChoice,
  handleBack,
  currentDraft,
  selectedDraft,
  handleDraftSelect,
  deleteDraft,
  setSelectedDraft,
  nodes,
  setNodes,
  selectedNode,
  setSelectedNode,
  expandedKeys,
  setExpandedKeys,
  pathNodes,
  setPathNodes,
  showDialog,
  setShowDialog,
  setDialogType,
  setQuestion,
  setResponse,
  updateNode,
  addChildNode,
  removeNode,
  findParent,
  menuRefs,
  handleAddFirstNode,
  hasChanges,
  showInstructions,
  setShowInstructions,
  editHistory,
  selectedVersion,
  loadVersion,
  visibleHistory,
  totalRecords,
  isLoading,
  question,
  setQuestionCount,
  questionCount,
  response,
  setResponseCount,
  responseCount,
  handleEditorChange,
  handleSaveNode
}) => {
  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <ChatHeader
        isEnabled={isEnabled}
        handleToggleChange={handleToggleChange}
        showSimulator={showSimulator}
        setShowSimulator={setShowSimulator}
        saveChatJourney={saveChatJourney}
        isMobile={isMobile}
      />
      {showSimulator ? (
        <div className="simulator-container">
          <ChatSimulator
            chatHistory={chatHistory}
            setChatHistory={setChatHistory}
            currentNode={currentNode}
            parentNode={parentNode}
            handleUserChoice={handleUserChoice}
            handleBack={handleBack}
          />
        </div>
      ) : (
        <>
          <CurrentDraft
            currentDraft={currentDraft}
            selectedDraft={selectedDraft}
            handleDraftSelect={handleDraftSelect}
            deleteDraft={deleteDraft}
            setSelectedDraft={setSelectedDraft}
          />
          <ChatJourneyBuilder
            isEnabled={isEnabled}
            nodes={nodes}
            selectedNode={selectedNode}
            setSelectedNode={setSelectedNode}
            expandedKeys={expandedKeys}
            setExpandedKeys={setExpandedKeys}
            pathNodes={pathNodes}
            setPathNodes={setPathNodes}
            showDialog={showDialog}
            setShowDialog={setShowDialog}
            setDialogType={setDialogType}
            setQuestion={setQuestion}
            setResponse={setResponse}
            updateNode={updateNode}
            addChildNode={addChildNode}
            removeNode={removeNode}
            findParent={findParent}
            menuRefs={menuRefs}
            toast={toast}
            setNodes={setNodes}
            currentNode={currentNode}
            handleAddFirstNode={handleAddFirstNode}
            hasChanges={hasChanges}
            saveChatJourney={saveChatJourney}
            showInstructions={showInstructions}
            setShowInstructions={setShowInstructions}
          />
          <HistoryPanel
            isEnabled={isEnabled}
            editHistory={editHistory}
            selectedVersion={selectedVersion}
            loadVersion={loadVersion}
            visibleHistory={visibleHistory}
            totalRecords={totalRecords}
            isLoading={isLoading}
            toast={toast}
            setNodes={setNodes}
            currentNode={currentNode}
          />
        </>
      )}
      <Dialog
        visible={showDialog !== 0}
        onHide={() => setShowDialog(0)}
        header={DIALOG_HEADER}
        style={{ width: DIALOG_WIDTH }}
        className={DIALOG_CLASS}
      >
        <div className="p-fluid">
          {(selectedNode === null && showDialog !== 0) || (selectedNode?.key === '0' && showDialog === 2) ? (
            <>
              <div className="mb-6">
                <span className="mb-2">{WELCOMING_MESSAGE_LABEL}</span>
                <div className="editor-container">
                  <Editor
                    value={question}
                    onTextChange={(e) => handleEditorChange(e, true)}
                    style={{ height: EDITOR_HEIGHT }}
                    className={questionCount > QUESTION_MAX_LENGTH ? P_INVALID_CLASS : ''}
                    headerTemplate={renderEditorHeader()}
                  />
                </div>
                <small className="p-error" style={{ display: questionCount > QUESTION_MAX_LENGTH ? 'block' : 'none' }}>
                  {MESSAGE_EXCEED_LABEL}
                </small>
                <div className={CHAR_COUNTER_CLASS}>{questionCount}/{QUESTION_MAX_LENGTH} characters</div>
              </div>
            </>
          ) : (
            <>
              <div className="mb-6">
                <span className="mb-2">{CUSTOMER_QUESTION_LABEL}</span>
                <InputTextarea
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  autoResize
                  className={questionCount > QUESTION_MAX_LENGTH ? P_INVALID_CLASS : ''}
                />
                <small className="p-error" style={{ display: questionCount > QUESTION_MAX_LENGTH ? 'block' : 'none' }}>
                  {QUESTION_EXCEED_LABEL}
                </small>
                <div className={CHAR_COUNTER_CLASS}>{questionCount}/{QUESTION_MAX_LENGTH} characters</div>
              </div>
              <div className="mb-6">
                <span className="mb-2">{BOT_RESPONSE_LABEL}</span>
                <div className="editor-container">
                  <Editor
                    value={response}
                    onTextChange={(e) => handleEditorChange(e, false)}
                    style={{ height: EDITOR_HEIGHT }}
                    className={responseCount > RESPONSE_MAX_LENGTH ? P_INVALID_CLASS : ''}
                    headerTemplate={renderEditorHeader()}
                  />
                </div>
                <small className="p-error" style={{ display: responseCount > RESPONSE_MAX_LENGTH ? 'block' : 'none' }}>
                  {RESPONSE_EXCEED_LABEL}
                </small>
                <div className={CHAR_COUNTER_CLASS}>{responseCount}/{RESPONSE_MAX_LENGTH} characters</div>
              </div>
            </>
          )}
        </div>
        <div className="dialog-footer" style={{ marginTop: '1rem' }}>
          <Button label={CANCEL_LABEL} className={TEXT_BUTTON_CLASS} onClick={() => setShowDialog(0)} />
          <Button
            label={SAVE_LABEL}
            className={PRIMARY_BUTTON_CLASS}
            icon={SAVE_ICON}
            onClick={() => handleSaveNode(nodes, setNodes)}
            disabled={questionCount > QUESTION_MAX_LENGTH || responseCount > RESPONSE_MAX_LENGTH}
          />
        </div>
      </Dialog>
    </>
  );
};

export default ChatJourneyTwoPanelView;
